import Vue from "vue";

// import Vue2OrgTree from "vue2-org-tree";

// Vue.use(Vue2OrgTree);
// Vue.component("vue2-org-tree", Vue2OrgTree);

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n

import "@/styles/index.scss"; // global css

import App from "./App";
import store from "./store";
import router from "./router";

import "@/icons"; // icon
import "@/permission"; // permission control

import axios from "axios"; // 引入axios
// 全局挂载axios到Vue原型
Vue.prototype.$axios = axios;
// 可选：配置axios默认请求地址（根据项目实际接口地址调整）
// axios.defaults.baseURL = "http://192.168.1.7:8095/api"; // 替换为你的后端接口前缀

import VueQuillEditor from "vue-quill-editor";

// 全局注册插件（必须！3.0.6 版本依赖全局注册）
Vue.use(VueQuillEditor);

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */

if (process.env.NODE_ENV === "production") {
  const { mockXHR } = require("../mock");
  mockXHR();
}

// set ElementUI lang to EN
Vue.use(ElementUI, { locale });
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});
